import { CircleCheck } from 'lucide-react'
import { useFormContext } from 'react-hook-form'

import { cn } from '@fortem-monorepo/js-utilities'
import {
  Button,
  FormError,
  FormField,
  FormItem,
  FormLabel,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@fortem-monorepo/react-ui'

import { SchemaType } from '@/components/forms/RunRiskCalibrationForm/RunRiskCalibrationForm.schema'
import { FUNDS, REPORT_TYPES } from '@/components/forms/RunRiskCalibrationForm/enums'

export interface ReportsFieldProps {}

export const ReportsField: React.FC<ReportsFieldProps> = ({}) => {
  const { control, setValue, watch } = useFormContext<SchemaType>()

  const reports_dct = watch('reports_dct')

  return (
    <FormField
      name="reports_dct"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <div className="flex items-center gap-2">
                <FormLabel>Select Reports</FormLabel>
                <FormError />
              </div>
              <div className="flex items-center gap-2">
                <Button
                  type="button"
                  size="sm"
                  variant={'outline'}
                  onClick={() => {
                    const newValue = FUNDS.reduce((prev, curr) => {
                      return {
                        ...prev,
                        [curr]: [...REPORT_TYPES],
                      }
                    }, {})
                    setValue('reports_dct', newValue, { shouldValidate: true })
                  }}
                >
                  Select all
                </Button>
                <Button
                  type="button"
                  size="sm"
                  variant={'outline'}
                  onClick={() => {
                    setValue('reports_dct', {}, { shouldValidate: true })
                  }}
                >
                  Clear all
                </Button>
              </div>
            </div>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead />
                  {REPORT_TYPES.map((t) => (
                    <TableHead key={t} className={'text-center'}>
                      {t}
                    </TableHead>
                  ))}
                </TableRow>
              </TableHeader>
              <TableBody>
                {FUNDS.map((fund) => {
                  return (
                    <TableRow className={'hover:bg-transparent!'}>
                      <TableCell>{fund}</TableCell>
                      {REPORT_TYPES.map((t) => {
                        const isSelected = reports_dct?.[fund]?.includes(t)
                        return (
                          <TableCell key={t} className={'relative p-0!'}>
                            <div
                              className={cn(
                                'absolute top-0 left-0 w-full h-full bg-sidebar cursor-pointer flex items-center justify-center hover:bg-gray-100',
                                {},
                              )}
                              onClick={() => {
                                let newValue = Object.assign({}, { ...reports_dct })

                                if (!newValue[fund]) {
                                  newValue[fund] = []
                                }

                                const isSelected = newValue[fund].includes(t)

                                if (isSelected) {
                                  newValue[fund] = newValue[fund].filter((report) => report !== t)
                                } else {
                                  newValue[fund].push(t)
                                }

                                newValue = Object.entries(newValue).reduce(
                                  (prev, [fund_name, reports]) => {
                                    return {
                                      ...prev,
                                      ...(reports.length > 0 ? { [fund_name]: reports } : {}),
                                    }
                                  },
                                  {},
                                )

                                setValue('reports_dct', newValue, { shouldValidate: true })
                              }}
                            >
                              <CircleCheck
                                className={cn('transition-all stroke-1 duration-250', {
                                  'text-green-600 stroke-[1.5]': isSelected,
                                  '[&>path]:scale-0 text-red-600/50': !isSelected,
                                })}
                              />
                            </div>
                          </TableCell>
                        )
                      })}
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </FormItem>
        )
      }}
    />
  )
}
